"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuidePieSmallSubscribed = void 0;
var react_1 = require("react");
var miniPubSub_1 = require("../lib/miniPubSub");
var guidePieSmall_1 = __importDefault(require("./guidePieSmall"));
var React = __importStar(require("react"));
// Created by react_component() helper in rails-react.
// noinspection JSUnusedGlobalSymbols
exports.GuidePieSmallSubscribed = function (props) {
    var _a = react_1.useState(props.initialPercentage), percentage = _a[0], setPercentage = _a[1];
    var subscriber = react_1.useState(function () { return function (percentage) { return setPercentage(percentage); }; })[0];
    miniPubSub_1.miniPubSub.subscribe(props.subscribeKey, subscriber);
    return React.createElement(guidePieSmall_1.default, { percentage: percentage });
};
